var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenuesSpaces = function SvgVenuesSpaces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M2 8v3.333m0 0h1.333c.943 0 1.415 0 1.707.293s.293.765.293 1.707V14M2 11.333V14M2.667 4.667 6.21 2.722C7.09 2.241 7.528 2 8.001 2c.471 0 .91.24 1.788.722l3.544 1.945M12 4v2.667M4 4v2.667M14 8v3.333m0 0h-1.333c-.943 0-1.415 0-1.707.293s-.293.765-.293 1.707V14M14 11.333V14M4.667 9.334H8m0 0h3.333M8 9.334V14m0 0h-.667M8 14h.667"
  })));
};
export default SvgVenuesSpaces;